import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconCheck from 'components/icons/IconCheck';
import IconCross from 'components/icons/IconCross';

const styles = theme => ({
  root: {
    marginTop: 8,
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    paddingTop: 8,
    paddingBottom: 8,
  },
  typography: {
    paddingBottom: 2,
    marginBottom: 8,
    marginTop: 4,
  },
  iconCheck: {
    display: 'inline-block',
    width: 18,
    height: 14,
    verticalAlign: 'middle',
    color: theme.palette.primary[500],
  },
  iconCross: {
    display: 'inline-block',
    width: 18,
    height: 14,
    verticalAlign: 'middle',
    color: theme.palette.validation[500],
  },
  grid: {
    marginTop: 0,
  },
});

const UserCreateEditFormSection = ({
  Group,
  items,
  classes,
}) => (
  <div className={classes.root}>
    <Grid
      container
      alignItems="flex-start"
      spacing={16}
      wrap="nowrap"
    >
      <Grid
        item
        xs={3}
      >
        <Typography
          color="secondary"
          variant="subheading"
          className={classes.typography}
        >
          {Group}
        </Typography>
      </Grid>
      <Grid
        item
        xs={9}
      >
        <div>
          {items.map(item => (
            <Grid
              className={classes.grid}
              key={item.ID}
              container
              alignItems="flex-start"
              spacing={16}
              wrap="nowrap"
            >
              <Grid item>
                {item.active ? (
                  <IconCheck
                    className={classes.iconCheck}
                  />
                ) : (
                  <IconCross
                    className={classes.iconCross}
                  />
                )}
              </Grid>
              <Grid
                item
                xs={11}
              >
                <Typography>
                  {item.Name}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </div>
      </Grid>
    </Grid>
  </div>
);

UserCreateEditFormSection.propTypes = {
  Group: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
    grid: PropTypes.string.isRequired,
    iconCheck: PropTypes.string.isRequired,
  }).isRequired,
};

UserCreateEditFormSection.defaultProps = {
  prefix: '',
};

export default withStyles(styles)(UserCreateEditFormSection);



// WEBPACK FOOTER //
// ./src/components/settings/UserCreateEditForm/UserCreateEditFormSection.js